var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeviceUpdatedLog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-device_updated"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "device_updated",
    clipPath: "url(#clip-device_updated)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1213",
    "data-name": "Grupo 1213",
    transform: "translate(-0.12 -63.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_575",
    "data-name": "Trazado 575",
    d: "M41.582,115.122H18.84a5.726,5.726,0,0,1-5.72-5.719V77.043a5.727,5.727,0,0,1,5.72-5.72H41.582a5.726,5.726,0,0,1,5.719,5.72V109.4A5.725,5.725,0,0,1,41.582,115.122ZM18.84,73.323a3.724,3.724,0,0,0-3.72,3.72V109.4a3.724,3.724,0,0,0,3.72,3.719H41.582A3.724,3.724,0,0,0,45.3,109.4V77.043a3.724,3.724,0,0,0-3.719-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_576",
    "data-name": "Trazado 576",
    d: "M38.379,93.379a1,1,0,0,0-1,1,7.168,7.168,0,1,1-8.968-6.931l-1.842,3.427a1,1,0,0,0,1.762.948l2.76-5.138a.366.366,0,0,0,.013-.044.988.988,0,0,0,.062-.211.916.916,0,0,0,.036-.179c0-.014.009-.026.009-.041a.954.954,0,0,0-.038-.184.994.994,0,0,0-.018-.144c0-.01-.012-.016-.016-.026A.956.956,0,0,0,31,85.621a1.134,1.134,0,0,0-.066-.1,1,1,0,0,0-.317-.224l-.007,0h0l-.012,0L25.253,82.98a1,1,0,1,0-.793,1.836l2.4,1.037a9.165,9.165,0,1,0,12.519,8.526A1,1,0,0,0,38.379,93.379Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceUpdatedLog);
export default __webpack_public_path__ + "static/media/icon_device_updated_log.348aafdbf74904f45cde98c7297d7f17.svg";
export { ForwardRef as ReactComponent };